import React, { InputHTMLAttributes } from 'react';
import Search from './icons/ic_search_24px.svg'
import './Cloud.scss';

export interface AlertProps  extends InputHTMLAttributes<HTMLInputElement> {
  icon:{
        type?:'search'
        onClick?:Function
    }
}

const Cloud: React.FC<AlertProps> = ({
  icon,
  ...props
}) => {
  return (
    
    <div className={`zero-form-field ${!props.placeholder ? 'without-placeholder' : ''}`}>
          <input {...props} />
          <label>{props.placeholder}</label>
          {
              icon.type ?
                  <img src={icon.type ? Search : ''} onClick={() => (icon.onClick)?icon.onClick():null} alt='' />
                  : null
          }
      </div>
  
  );
};

export default Cloud;
